import Card from "../../../ui/Card/Card";
import Tabs from "../../../ui/Tabs/Tabs";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import urls from "../../../routes";
import Recommendations from "./Recommendations/Recommendations";
import Options from "./Options/Options";
import styles from "./Keywords.module.scss";

function Generation() {
  const navigate = useNavigate();
  const { tabValue, subTabValue } = useParams();

  // Using URL params causes this tab to be rendered once more before being unmounted
  if (tabValue === "keywords" && !subTabValue) {
    return <Navigate replace to={urls.settings.keywords.recommendations} />;
  }

  return (
    <Card className={styles.card}>
      <Tabs
        classNames={{ list: styles.tabsList, content: styles.tabsContent }}
        value={subTabValue}
        onValueChange={(value) =>
          navigate(`${urls.settings.keywords.root}/${value}`)
        }
        tabs={[
          {
            id: "recommendations",
            label: "Recommendations",
            content: <Recommendations />,
          },
          {
            id: "options",
            label: "Options",
            content: <Options />,
          },
        ]}
      />
    </Card>
  );
}

export default Generation;
